import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=09506ecc&scoped=true&lang=html"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09506ecc",
  null
  
)

export default component.exports